//types
export const PREVIEWER_IMAGE_LIST = 'ANNOTATION/PREVIEWER/LIST';
export const PREVIEWER_IMAGE_VISIBLE = 'ANNOTATION/PREVIEWER/VISIBLE';
export const PREVIEWER_IMAGE_INIT = 'ANNOTATION/PREVIEWER/INIT';
export const PREVIEWER_IMAGE_SELECT = 'ANNOTATION/PREVIEWER/SELECT';

export const setPreviewerSelect = selectedImage => ({ type: PREVIEWER_IMAGE_SELECT, selectedImage });
export const setPreviewerInit = () => ({ type: PREVIEWER_IMAGE_INIT });
export const setPreviewerList = fileList => ({ type: PREVIEWER_IMAGE_LIST, fileList });
export const setPreviewerVisible = visible => ({ type: PREVIEWER_IMAGE_VISIBLE, visible });